import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import config from '../../../envConfig';

interface IAppNavigateProps {
  to: string;
  replace?: boolean;
}

export default function AppNavigate(props: IAppNavigateProps) {
  const { to, replace = true } = props;
  const { navigate, replace: replaceNav } = useNavigationStack();

  useEffect(() => {
    if (!config.mobileRouting) {
      return;
    }
    if (replace) {
      replaceNav(to);
    } else {
      navigate(to);
    }
  }, [to, replace, navigate, replaceNav]);

  if (!config.mobileRouting) {
    return <Navigate to={to} replace={replace} />;
  }

  return null;
}
